function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint class-methods-use-this: "off" */

import Log from '@deephaven/log';
import TableColumnFormatter from "./TableColumnFormatter.js";
var log = Log.module('DateTimeColumnFormatter');
export class DateTimeColumnFormatter extends TableColumnFormatter {
  /**
   * Validates format object
   * @param dh JSAPI instance
   * @param format Format object
   * @returns true for valid object
   */
  static isValid(dh, format) {
    if (format.formatString == null) {
      return false;
    }
    try {
      dh.i18n.DateTimeFormat.format(format.formatString, new Date());
      return true;
    } catch (e) {
      return false;
    }
  }
  static makeFormat(label, formatString) {
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : TableColumnFormatter.TYPE_CONTEXT_PRESET;
    return {
      label,
      formatString,
      type
    };
  }

  /**
   * Check if the given formats match
   * @param formatA format object to check
   * @param formatB format object to check
   * @returns True if the formats match
   */
  static isSameFormat(formatA, formatB) {
    return formatA === formatB || formatA !== null && formatB !== null && formatA.type === formatB.type && formatA.formatString === formatB.formatString;
  }
  static makeGlobalFormatStringMap(showTimeZone, showTSeparator) {
    var separator = showTSeparator ? "'T'" : ' ';
    var tz = showTimeZone ? ' z' : '';
    return new Map([['yyyy-MM-dd HH:mm:ss', "yyyy-MM-dd".concat(separator, "HH:mm:ss").concat(tz)], ['yyyy-MM-dd HH:mm:ss.SSS', "yyyy-MM-dd".concat(separator, "HH:mm:ss.SSS").concat(tz)], ['yyyy-MM-dd HH:mm:ss.SSSSSSSSS', "yyyy-MM-dd".concat(separator, "HH:mm:ss.SSSSSSSSS").concat(tz)]]);
  }
  static getGlobalFormats(showTimeZone, showTSeparator) {
    var formatStringMap = DateTimeColumnFormatter.makeGlobalFormatStringMap(showTimeZone, showTSeparator);
    return [...formatStringMap.keys()];
  }
  static makeFormatStringMap(showTimeZone, showTSeparator) {
    var separator = showTSeparator !== undefined && showTSeparator ? "'T'" : ' ';
    var tz = showTimeZone !== undefined && showTimeZone ? ' z' : '';
    return new Map([['yyyy-MM-dd', "yyyy-MM-dd".concat(tz)], ['MM-dd-yyyy', "MM-dd-yyyy".concat(tz)], ['HH:mm:ss', "HH:mm:ss".concat(tz)], ['HH:mm:ss.SSS', "HH:mm:ss.SSS".concat(tz)], ['HH:mm:ss.SSSSSSSSS', "HH:mm:ss.SSSSSSSSS".concat(tz)], ['yyyy-MM-dd HH:mm:ss', "yyyy-MM-dd".concat(separator, "HH:mm:ss").concat(tz)], ['yyyy-MM-dd HH:mm:ss.SSS', "yyyy-MM-dd".concat(separator, "HH:mm:ss.SSS").concat(tz)], ['yyyy-MM-dd HH:mm:ss.SSSSSSSSS', "yyyy-MM-dd".concat(separator, "HH:mm:ss.SSSSSSSSS").concat(tz)]]);
  }
  static getFormats(showTimeZone, showTSeparator) {
    var formatStringMap = DateTimeColumnFormatter.makeFormatStringMap(showTimeZone, showTSeparator);
    return [...formatStringMap.keys()];
  }
  constructor(dh) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$timeZone = _ref.timeZone,
      timeZoneParam = _ref$timeZone === void 0 ? '' : _ref$timeZone,
      _ref$showTimeZone = _ref.showTimeZone,
      showTimeZone = _ref$showTimeZone === void 0 ? true : _ref$showTimeZone,
      _ref$showTSeparator = _ref.showTSeparator,
      showTSeparator = _ref$showTSeparator === void 0 ? false : _ref$showTSeparator,
      _ref$defaultDateTimeF = _ref.defaultDateTimeFormatString,
      defaultDateTimeFormatString = _ref$defaultDateTimeF === void 0 ? DateTimeColumnFormatter.DEFAULT_DATETIME_FORMAT_STRING : _ref$defaultDateTimeF;
    super();
    _defineProperty(this, "dh", void 0);
    _defineProperty(this, "dhTimeZone", void 0);
    _defineProperty(this, "defaultDateTimeFormatString", void 0);
    _defineProperty(this, "showTimeZone", void 0);
    _defineProperty(this, "showTSeparator", void 0);
    _defineProperty(this, "formatStringMap", void 0);
    var timeZone = timeZoneParam || DateTimeColumnFormatter.DEFAULT_TIME_ZONE_ID;
    try {
      this.dhTimeZone = dh.i18n.TimeZone.getTimeZone(timeZone);
    } catch (e) {
      log.error('Unsupported time zone id', timeZone);
      this.dhTimeZone = dh.i18n.TimeZone.getTimeZone(DateTimeColumnFormatter.DEFAULT_TIME_ZONE_ID);
    }
    this.dh = dh;
    this.defaultDateTimeFormatString = defaultDateTimeFormatString;
    this.showTimeZone = showTimeZone;
    this.showTSeparator = showTSeparator;
    this.formatStringMap = DateTimeColumnFormatter.makeFormatStringMap(showTimeZone, showTSeparator);
  }
  getEffectiveFormatString(baseFormatString) {
    var _this$formatStringMap;
    return (_this$formatStringMap = this.formatStringMap.get(baseFormatString)) !== null && _this$formatStringMap !== void 0 ? _this$formatStringMap : baseFormatString;
  }
  format(value) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var baseFormatString = format.formatString != null && format.formatString !== '' ? format.formatString : this.defaultDateTimeFormatString;
    var formatString = this.getEffectiveFormatString(baseFormatString);
    try {
      return this.dh.i18n.DateTimeFormat.format(formatString, value, this.dhTimeZone);
    } catch (e) {
      log.error('Invalid format arguments');
    }
    return '';
  }
}
_defineProperty(DateTimeColumnFormatter, "DEFAULT_DATETIME_FORMAT_STRING", 'yyyy-MM-dd HH:mm:ss.SSS');
_defineProperty(DateTimeColumnFormatter, "DEFAULT_TIME_ZONE_ID", 'America/New_York');
export default DateTimeColumnFormatter;
//# sourceMappingURL=DateTimeColumnFormatter.js.map